import store from '../store'
const userDefaults = {
  id          : 0,          // From Auth
  name        : 'Turkish Restaurant', // From Auth
  last_name   : '',
  full_name   : '',
  photoURL    : require('@/assets/images/logo/logo.png'), // From Auth
  photo       : require('@/assets/images/logo/logo.png'), // From Auth
  email       : 'info@turkishrestaurant.com',
  user_group  : 'admin',
  user_property: {}
}
const addressDefaults = {
  id: 0,
  user_id:0,
  name: '',
  full_name: '',
  email: '',
  phone: '',
  address: 'Create an address',
  coordinate: '',
  region: '',
  city: '',
  district: '',
  post_code: '',
  default: 0,
  is_active:1
}
const searchDataDefault = {
  restaurants: {
    key: 'title',
    data: []
  },
  products: {
    key: 'title',
    data: []
  }
}

const searchRestaurantDataDefault = {
  restaurants: {
    key: 'title',
    data: []
  }
}

export default {
  place_service: null,
  saved_user_id: null,
  post_commit_status: '',
  restaurantlist: [],
  arealist: [],
  restaurantlistall: [],
  cateringRestaurantlist: [],
  restaurant: null,
  checkout_restaurant: null,
  currentUser: userDefaults,
  defaultAddress: addressDefaults,
  deliveryAddress: addressDefaults,
  current_content: null,
  pass: false,
  contents: [],
  coupons: [],
  selected_city: '',
  deliveryMethods: [],
  selected_image: '/image/locations/main_background.jpg',
  page_contents: [],
  blog_contents: [],
  searchData: null,
  searchResultData: searchDataDefault,
  searchRestaurantData: searchRestaurantDataDefault,
  propertylist: [],
  isMobile: false,
  isInited: false,
  showWebsite: false,
  showRestaurantLogo: false,
  showCart: false,
  isScrolled: false,
  isCartBackground: false,
  showSearch: false,
  orderList: [],
  sizelist: [],
  sizeOptions: [],
  productlist: [],
  modifierlist: [],
  productCategories: [],
  cateringCategories: [],
  address_list: [],
  coupon: '',
  gift: null,
  selected_date_result: null,
  token_valid: false,
  checkout_page: false,
  checkout_stage: 0,
  liveCities: null,
  isUserLoggedIn: async () => {
    let isAuthenticated = false

    await store.dispatch('api/checkTokenValid').then((response) => {
      if (response.data.status === true) {
        isAuthenticated = true
      } else {
        isAuthenticated = false
        localStorage.clear()
      }
    }).catch(error => {
      isAuthenticated = error.message
    })

    return isAuthenticated
  },
  giftCards: []
  
}
